// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"09163d14","881":"7c8ddefa"}[chunkId] + ".chunk.js";
};